"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissions = void 0;
exports.permissions = {
    module: {
        get: "challenge:get",
        listing: "challenge:listing",
        create: "challenge:create",
        update: "challenge:update",
        delete: "challenge:delete",
        members: "challenge:members",
        groups: "challenge:groups",
        experts: "challenge:coaches",
        approvers: "challenge:approvers",
        manageParticipants: "challenge:manage_participants",
        duplicate: "challenge:duplicate",
        archive: "challenge:archive",
        useTemplate: "challenge:use_template",
        join: "challenge:join",
        show: "challenge:show",
        moduleReport: "challenge:module_report",
        surveyReport: "challenge:survey_report",
        canSeeJoinInfoModal: "challenge:see_join_data_access_modal",
    },
    traq: {
        create: "rank:create",
        update: "rank:update",
        delete: "rank:delete",
        listing: "rank:listing",
        members: "rank:members",
        experts: "rank:coaches",
        approvers: "rank:approvers",
        get: "rank:get",
        duplicate: "rank:duplicate",
        archive: "rank:archive",
        join: "rank:join",
        useTemplate: "rank:useTemplate",
        manageParticipants: "rank:manage_participants",
        canSeeJoinInfoModal: "rank:see_join_data_access_modal",
    },
    step: {
        listing: "achievement:listing",
        create: "achievement:create",
        update: "achievement:update",
        get: "achievement:get",
        delete: "achievement:delete",
        proofFile: "achievement:proof_file",
        textProof: "achievement:proof_text",
        approve: "achievement:approve",
        validate: "achievement:validate",
    },
    level: {
        listing: "level:listing",
        create: "level:create",
        update: "level:update",
        get: "level:get",
        delete: "level:delete",
    },
    social: {
        friends: "social:friends",
        users: "social:users",
        experts: "social:experts",
    },
    approve: {
        users: "achievement:validate_users",
        groups: "achievement:validate_groups",
        modules: "achievement:validate_modules",
        steps: "achievement:validate_steps",
    },
    reports: {
        userReports: "traqing:reports",
        management: "traqing:coach",
    },
    group: {
        listing: "team:listing",
        listingNotMy: "team:listing_not_my",
        create: "team:create",
        update: "team:update",
        delete: "team:delete",
        get: "team:get",
        manageMembers: "team:manage_members",
        archive: "team:archive",
        suggestModules: "team:suggest_modules",
        manageSuggestions: "team:manage_suggestions",
        activityLog: "team:activity_log",
        invite: "team:invite",
        joinWithoutInvite: "team:join_without_invite",
    },
    conversation: {
        listing: "conversation:listing",
        sendMessage: "conversation:send_message",
        seeOwnMessages: "conversation:see_own_messages",
        sendAttachment: "conversation:send_attachments",
        startConversation: "conversation:start_conversation",
        group: "conversation:group",
        chatWithClient: "conversation:chat_with_client",
        chatWithValidator: "conversation:chat_with_validator",
        chatWithCoach: "conversation:chat_with_coach",
        chatWithProvider: "conversation:chat_with_provider",
        moduleChat: "conversation:module_conversation",
        traqChat: "conversation:rank_conversation",
    },
    notification: {
        listing: "notification:listing",
    },
    system: {
        logout: "system:logout",
        hubspot: "system:hubspot",
        changePassword: "system:change_password",
        changeEmail: "system:change_email",
        support: "system:support",
    },
    activityLogs: {
        all: "activity_log:all",
        my: "activity_log:my",
        users: "activity_log:users",
    },
    explorer: {
        module: "explorer_view:modules",
        users: "explorer_view:users",
        groups: "explorer_view:groups",
    },
    note: {
        create: "note:create",
        update: "note:update",
        delete: "note:delete",
        share: "note:share",
        index: "note:index",
        show: "note:show",
    },
    tags: {
        create: "category:create",
        update: "category:update",
        delete: "category:delete",
        systemTags: "category:system",
        customTags: "category:custom",
    },
    subTags: {
        create: "area_of_interest:create",
        update: "area_of_interest:update",
        delete: "area_of_interest:delete",
    },
    profile: {
        updateOwnFullname: "profile:update_own_fullname",
        updateOwnLocation: "profile:update_own_location",
        updateOwnBio: "profile:update_own_bio",
        updateOwnTags: "profile:update_own_tags",
        updateOwnCover: "profile:update_own_cover",
        updateOwnAvatar: "profile:update_own_avatar",
        updateUserFullname: "profile:update_user_fullname",
        updateUserLocation: "profile:update_user_location",
        updateUserBio: "profile:update_user_bio",
        updateUserTags: "profile:update_user_tags",
        updateUserCover: "profile:update_user_cover",
        updateUserAvatar: "profile:update_user_avatar",
        manageOwnConnections: "profile:manage_own_connections",
    },
    user: {
        accessGeneralSettings: "user:access_general_settings",
        seeTextSubmission: "user:see_text_submissions",
        manageExperts: "user:manage_my_experts",
    },
    contentReport: {
        create: "content_report:create",
        review: "content_report:review",
    },
    explorerPresets: {
        create: "explorer_presets:create",
        use: "explorer_presets:use",
    },
};
